export default __webpack_public_path__ + "static/media/INTEGRITY-UNDERTAKING-Vishakha.ef2adae2.doc";